// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-contentful-blog-post-js": () => import("./../../../src/templates/contentful-blog-post.js" /* webpackChunkName: "component---src-templates-contentful-blog-post-js" */)
}

